import { useState, useEffect } from "react";
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";
import { readString } from "react-papaparse";
// Components
import Routes from "../routes";
// Translation file
import translationsPath from "./translations/translations.csv";

const I18Next = ({ language }) => {
  const [translations, setTranslations] = useState({});

  // Set translations
  useEffect(() => {
    const fetchTranslations = async () => {
      try {
        const response = await fetch(translationsPath);
        const csvText = await response.text();

        readString(csvText, {
          header: true,
          skipEmptyLines: true,
          complete: (results) => {
            let translations = {
              English: {},
              Spanish: {},
              Catalan: {},
              Portuguese: {},
              French: {},
              Italian: {},
              Romanian: {},
              Dutch: {},
              German: {},
              Ukrainian: {},
              Chinese: {},
              ChineseTraditional: {},
            };

            for (const row of results.data) {
              const key = row.key;
              Object.keys(translations).forEach((lang) => {
                if (row[lang]) {
                  translations[lang][key] = row[lang] === " " ? "" : row[lang];
                }
              });
            }

            setTranslations(translations);
          },
          error: (error) => {
            console.error("Error parsing CSV:", error);
          },
        });
      } catch (error) {
        console.error("Error fetching or initializing translations:", error);
      }
    };

    fetchTranslations();
  }, []);

  // Set language
  useEffect(() => {
    i18next.init({
      interpolation: { escapeValue: false },
      lng: language,
      resources: {
        English: {
          global: translations.English || {},
        },
        Spanish: {
          global: translations.Spanish || {},
        },
        Catalan: {
          global: translations.Catalan || {},
        },
        Portuguese: {
          global: translations.Portuguese || {},
        },
        French: {
          global: translations.French || {},
        },
        Italian: {
          global: translations.Italian || {},
        },
        Romanian: {
          global: translations.Romanian || {},
        },
        Dutch: {
          global: translations.Dutch || {},
        },
        German: {
          global: translations.German || {},
        },
        Ukrainian: {
          global: translations.Ukrainian || {},
        },
        Chinese: {
          global: translations.Chinese || {},
        },
        ChineseTraditional: {
          global: translations.ChineseTraditional || {},
        },
      },
    });
  }, [translations, language]);

  return (
    <I18nextProvider i18n={i18next}>
      <Routes />
    </I18nextProvider>
  );
};

export default I18Next;
